module.exports = __webpack_public_path__ + "img/e_voucher_logo_blue_conasi.c7ef98eb.png";